/**
 * Chloe D Beauty - Shopify 2.0 Theme JS Engine
 * Edit Modern Minimalism Aesthetics (75/25 Monochrome #FFFFFF / #111111)
 */

document.addEventListener('DOMContentLoaded', () => {
  initHeroSlideshow();
  initCartDrawer();
  initMobileMenu();
  initProductForms();
  initTreatmentFilterTabs();
  initProductSlider();
});

/* ==========================================================================
   1. HERO SLIDESHOW CONTROLLER (11 Assets, Typographic Numbers)
   ========================================================================== */
function initHeroSlideshow() {
  const slideshow = document.querySelector('[data-hero-slideshow]');
  if (!slideshow) return;

  const slides = slideshow.querySelectorAll('.hero-slide-item');
  const buttons = slideshow.querySelectorAll('.hero-slide-btn, .hero-indicator-btn, [data-indicator-index], [data-slide-target]');
  const contents = slideshow.querySelectorAll('.hero-slide-content');
  if (!slides.length) return;

  let currentIndex = 0;
  const totalSlides = slides.length;
  let autoplayTimer = null;

  function goToSlide(index) {
    if (index < 0) index = totalSlides - 1;
    if (index >= totalSlides) index = 0;

    // Eliminate ghosting: enforce strict opacity, visibility and pointer events
    slides.forEach((slide, i) => {
      if (i === index) {
        slide.style.opacity = '1';
        slide.style.visibility = 'visible';
        slide.style.pointerEvents = 'auto';
        slide.classList.add('active');
      } else {
        slide.style.opacity = '0';
        slide.style.visibility = 'hidden';
        slide.style.pointerEvents = 'none';
        slide.classList.remove('active');
      }
    });

    contents.forEach((content, i) => {
      if (contents.length > 1) {
        if (i === index) {
          content.style.opacity = '1';
          content.style.visibility = 'visible';
          content.style.pointerEvents = 'auto';
          content.classList.add('active');
        } else {
          content.style.opacity = '0';
          content.style.visibility = 'hidden';
          content.style.pointerEvents = 'none';
          content.classList.remove('active');
        }
      } else {
        content.style.opacity = '1';
        content.style.visibility = 'visible';
        content.style.pointerEvents = 'auto';
        content.classList.add('active');
      }
    });

    buttons.forEach((btn, i) => {
      if (i === index) {
        btn.classList.add('active', 'border-white', 'opacity-100', 'text-[#FFFFFF]', 'font-bold');
        btn.classList.remove('border-transparent', 'opacity-60', 'font-normal');
        btn.setAttribute('aria-current', 'true');
      } else {
        btn.classList.remove('active', 'border-white', 'opacity-100', 'text-[#FFFFFF]', 'font-bold');
        btn.classList.add('border-transparent', 'opacity-60', 'font-normal');
        btn.removeAttribute('aria-current');
      }
    });

    currentIndex = index;
  }

  function startAutoPlay() {
    if (autoplayTimer) clearInterval(autoplayTimer);
    autoplayTimer = setInterval(() => {
      const nextIndex = (currentIndex + 1) % totalSlides;
      goToSlide(nextIndex);
    }, 6000);
  }

  // Autoplay pause on hover
  slideshow.addEventListener('mouseenter', () => {
    if (autoplayTimer) clearInterval(autoplayTimer);
  });

  slideshow.addEventListener('mouseleave', () => {
    startAutoPlay();
  });

  // Clickable numeric slide indicators (01, 02, etc.)
  buttons.forEach((btn, i) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const targetAttr = btn.getAttribute('data-slide-target') || btn.getAttribute('data-indicator-index');
      const targetIndex = targetAttr !== null ? parseInt(targetAttr, 10) : i;
      goToSlide(targetIndex);
      startAutoPlay();
    });
  });

  // Preload slides
  slides.forEach((slide) => {
    const bg = slide.getAttribute('data-bg');
    if (bg) {
      const img = new Image();
      img.src = bg;
    }
  });

  goToSlide(0);
  startAutoPlay();
}

/* ==========================================================================
   2. AJAX CART DRAWER ENGINE (Shopify AJAX API)
   ========================================================================== */
function initCartDrawer() {
  const drawerOverlay = document.querySelector('[data-cart-drawer-overlay]');
  const openButtons = document.querySelectorAll('[data-cart-drawer-open]');
  const closeButtons = document.querySelectorAll('[data-cart-drawer-close]');

  if (!drawerOverlay) return;

  function openCart() {
    drawerOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeCart() {
    drawerOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  openButtons.forEach((btn) => btn.addEventListener('click', openCart));
  closeButtons.forEach((btn) => btn.addEventListener('click', closeCart));

  drawerOverlay.addEventListener('click', (e) => {
    if (e.target === drawerOverlay) closeCart();
  });

  // Global helper accessible across any section
  window.ChloeCart = {
    open: openCart,
    close: closeCart,
    add: function (variantId, quantity = 1) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
        .then((res) => res.json())
        .then(() => {
          refreshCart();
          openCart();
        })
        .catch((err) => {
          console.warn('Shopify Cart add fallback:', err);
          openCart();
        });
    },
    change: function (key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then((res) => res.json())
        .then((cart) => {
          updateCartUI(cart);
        })
        .catch((err) => {
          console.warn('Cart change error:', err);
        });
    }
  };
}

function refreshCart() {
  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      updateCartUI(cart);
    })
    .catch((err) => {
      console.log('Cart preview state active:', err);
    });
}

function updateCartUI(cart) {
  // 1. Badge counters
  const countBadges = document.querySelectorAll('[data-cart-count], [data-cart-count-display]');
  countBadges.forEach((badge) => {
    if (badge.hasAttribute('data-cart-count-display')) {
      badge.textContent = `(${cart.item_count || 0})`;
    } else {
      badge.textContent = cart.item_count || 0;
    }
  });

  // 2. Subtotal
  const subtotalElem = document.querySelector('[data-cart-subtotal]');
  if (subtotalElem && cart.total_price !== undefined) {
    const formattedPrice = `R ${(cart.total_price / 100).toFixed(2)} ZAR`;
    subtotalElem.textContent = formattedPrice;
  }

  // 3. Cart Items List Rendering if items exist
  const container = document.querySelector('[data-cart-items-container]');
  if (container && cart.items && cart.items.length > 0) {
    let itemsHtml = '';
    cart.items.forEach((item) => {
      const itemPrice = `R ${(item.final_line_price / 100).toFixed(2)}`;
      itemsHtml += `
        <div class="flex items-center space-x-4 border-b border-[#111111]/10 pb-4">
          <img src="${item.image || ''}" alt="${item.title}" class="w-16 h-16 object-cover rounded">
          <div class="flex-1">
            <h4 class="font-serif-editorial text-base text-[#111111]">${item.product_title}</h4>
            <p class="font-sans-ui text-xs text-[#111111]/60">${item.variant_title || ''}</p>
            <div class="flex items-center justify-between mt-2">
              <span class="font-sans-ui text-xs font-semibold">${itemPrice}</span>
              <div class="flex items-center space-x-2">
                <button type="button" onclick="ChloeCart.change('${item.key}', ${item.quantity - 1})" class="text-xs px-1.5 py-0.5 border border-[#111111]/20 rounded">-</button>
                <span class="text-xs text-[#111111] font-mono">${item.quantity}</span>
                <button type="button" onclick="ChloeCart.change('${item.key}', ${item.quantity + 1})" class="text-xs px-1.5 py-0.5 border border-[#111111]/20 rounded">+</button>
              </div>
            </div>
          </div>
        </div>
      `;
    });
    container.innerHTML = itemsHtml;
  }
}

/* ==========================================================================
   3. PRODUCT FORM AJAX HANDLER
   ========================================================================== */
function initProductForms() {
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('#product-form');
    if (!form) return;

    e.preventDefault();
    const formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then((res) => res.json())
      .then(() => {
        if (window.ChloeCart && window.ChloeCart.open) {
          window.ChloeCart.open();
        }
      })
      .catch((err) => {
        console.warn('Shopify Cart add error:', err);
        if (window.ChloeCart && window.ChloeCart.open) {
          window.ChloeCart.open();
        }
      });
  });
}

/* ==========================================================================
   4. MOBILE NAVIGATION CONTROLLER
   ========================================================================== */
function initMobileMenu() {
  const toggle = document.querySelector('[data-mobile-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  const closeButtons = document.querySelectorAll('[data-mobile-menu-close]');

  if (!toggle || !menu) return;

  toggle.addEventListener('click', () => {
    menu.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  });

  closeButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      menu.classList.add('hidden');
      document.body.style.overflow = '';
    });
  });
}

/* ==========================================================================
   5. TREATMENT MENU CATEGORY FILTERS (11 Signature Treatments)
   ========================================================================== */
function initTreatmentFilterTabs() {
  const filterContainer = document.querySelector('[data-treatment-filters]');
  if (!filterContainer) return;

  const buttons = filterContainer.querySelectorAll('[data-treatment-filter]');
  const cards = document.querySelectorAll('[data-treatment-list] .treatment-card');

  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const targetCat = btn.getAttribute('data-treatment-filter');

      // Update button styles
      buttons.forEach((b) => {
        b.classList.remove('bg-[#111111]', 'text-[#FFFFFF]', 'font-bold', 'shadow-sm');
        b.classList.add('bg-[#FFFFFF]', 'text-[#111111]', 'border', 'border-[#111111]/20', 'font-medium');
      });

      btn.classList.remove('bg-[#FFFFFF]', 'border-[#111111]/20', 'font-medium');
      btn.classList.add('bg-[#111111]', 'text-[#FFFFFF]', 'font-bold', 'shadow-sm');

      // Filter cards
      cards.forEach((card) => {
        const cardCat = card.getAttribute('data-category');
        if (targetCat === 'all' || cardCat === targetCat) {
          card.style.display = 'flex';
        } else {
          card.style.display = 'none';
        }
      });
    });
  });
}

/* ==========================================================================
   6. BOOKSY CONCIERGE MODAL (External Trigger)
   ========================================================================== */
window.openBooksyModal = function () {
  window.open('https://chloedbeauty.booksy.com/a', '_blank', 'noopener,noreferrer');
};

/* ==========================================================================
   7. EDITORIAL PRODUCT IMAGE SLIDER (4:5 Gallery, Chevron & Touch Swipe)
   ========================================================================== */
function initProductSlider() {
  const slider = document.querySelector('[data-product-slider]');
  if (!slider) return;

  const track = slider.querySelector('[data-product-slider-track]');
  const slides = slider.querySelectorAll('.product-slide');
  const prevBtn = slider.querySelector('[data-product-slider-prev]');
  const nextBtn = slider.querySelector('[data-product-slider-next]');
  const currentCounter = slider.querySelector('[data-product-current-slide]');
  const totalCounter = slider.querySelector('[data-product-total-slides]');
  const thumbnails = slider.querySelectorAll('[data-thumbnail-target]');

  if (!track || slides.length === 0) return;

  let activeIndex = 0;
  const slideCount = slides.length;

  if (totalCounter) {
    totalCounter.textContent = String(slideCount).padStart(2, '0');
  }

  function updateSlider(index) {
    if (index < 0) index = slideCount - 1;
    if (index >= slideCount) index = 0;
    activeIndex = index;

    // Slide track transition
    track.style.transform = `translateX(-${activeIndex * 100}%)`;

    // Update editorial slide counter
    if (currentCounter) {
      currentCounter.textContent = String(activeIndex + 1).padStart(2, '0');
    }

    // Update thumbnail indicators
    thumbnails.forEach((thumb, i) => {
      if (i === activeIndex) {
        thumb.classList.remove('opacity-70', 'border-[#111111]/15');
        thumb.classList.add('border-[#111111]', 'ring-1', 'ring-[#111111]', 'opacity-100');
      } else {
        thumb.classList.remove('border-[#111111]', 'ring-1', 'ring-[#111111]', 'opacity-100');
        thumb.classList.add('border-[#111111]/15', 'opacity-70');
      }
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      updateSlider(activeIndex - 1);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      updateSlider(activeIndex + 1);
    });
  }

  thumbnails.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const targetIndex = parseInt(thumb.getAttribute('data-thumbnail-target'), 10);
      if (!isNaN(targetIndex)) {
        updateSlider(targetIndex);
      }
    });
  });

  // Touch Swipe Support for Mobile Viewports (40px Delta Threshold on .product-slider-viewport)
  const viewport = slider.querySelector('.product-slider-viewport') || track;
  let touchStartX = 0;
  let touchEndX = 0;

  viewport.addEventListener('touchstart', (e) => {
    if (e.changedTouches && e.changedTouches.length > 0) {
      touchStartX = e.changedTouches[0].screenX;
      touchEndX = touchStartX;
    }
  }, { passive: true });

  viewport.addEventListener('touchmove', (e) => {
    if (e.changedTouches && e.changedTouches.length > 0) {
      touchEndX = e.changedTouches[0].screenX;
    }
  }, { passive: true });

  viewport.addEventListener('touchend', () => {
    handleSwipe();
  }, { passive: true });

  function handleSwipe() {
    const swipeDistance = touchEndX - touchStartX;
    if (Math.abs(swipeDistance) > 40) {
      if (swipeDistance < 0) {
        // Swipe Left -> Next
        updateSlider(activeIndex + 1);
      } else {
        // Swipe Right -> Prev
        updateSlider(activeIndex - 1);
      }
    }
  }
}
